import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const mountedRoots = new WeakMap();

function unmountExisting(rootElement) {
  const existing = mountedRoots.get(rootElement);
  if (existing) {
    existing.unmount();
    mountedRoots.delete(rootElement);
  }
}

export function mountDiscovery(rootElement, basePath = '/', options = {}) {
  if (!rootElement) return null;
  unmountExisting(rootElement);
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App basePath={basePath} embedded={!!options.embedded} />
    </React.StrictMode>
  );
  mountedRoots.set(rootElement, root);
  return {
    unmount() {
      unmountExisting(rootElement);
    }
  };
}

if (typeof window !== 'undefined') {
  window.mountDiscovery = mountDiscovery;
  const script = typeof document !== 'undefined' && document.currentScript;
  const isEmbedded = script && script.getAttribute('data-discovery-bundle') === 'true';
  if (!isEmbedded) {
    const container = document.getElementById('root');
    if (container) mountDiscovery(container, '/');
  }
}
